module.exports = __webpack_public_path__ + "img/pro.8a679078.png";